import { create } from 'zustand';

type CanvasOverlayState = {
  edgeHover: string | null;
  isBoardDropTargetActive: boolean;
  nearConnectorNodeIds: string[];
  setEdgeHover: (edgeHover: string | null) => void;
  setBoardDropTargetActive: (isBoardDropTargetActive: boolean) => void;
  setNearConnectorNodeIds: (nearConnectorNodeIds: string[]) => void;
  /** H hides the prompt strips on generated images for this session. */
  hidePromptOverlays: boolean;
  toggleHidePromptOverlays: () => void;
  /** `${source}->${target}` of edges created moments ago; connectionEdge
   *  plays its draw-in for these. Never persisted: a remount (scrolling the
   *  edge back into view) must not replay it. */
  freshEdgeKeys: string[];
};

export const useCanvasOverlayStore = create<CanvasOverlayState>()(set => ({
  edgeHover: null,
  isBoardDropTargetActive: false,
  nearConnectorNodeIds: [],
  setEdgeHover: edgeHover => set({ edgeHover }),
  setBoardDropTargetActive: isBoardDropTargetActive => set({ isBoardDropTargetActive }),
  setNearConnectorNodeIds: nearConnectorNodeIds => set({ nearConnectorNodeIds }),
  hidePromptOverlays: false,
  toggleHidePromptOverlays: () => set(state => ({ hidePromptOverlays: !state.hidePromptOverlays })),
  freshEdgeKeys: [],
}));

export const FRESH_EDGE_MS = 400;

/** Flags edges to draw themselves in (300ms); cleared shortly after. */
export const markEdgesFresh = (edges: { source: string; target: string }[]) => {
  const keys = edges.map(edge => `${edge.source}->${edge.target}`);
  const added = new Set(keys);
  useCanvasOverlayStore.setState(state => ({ freshEdgeKeys: [...state.freshEdgeKeys, ...keys] }));
  setTimeout(() => {
    useCanvasOverlayStore.setState(state => ({
      freshEdgeKeys: state.freshEdgeKeys.filter(key => !added.has(key)),
    }));
  }, FRESH_EDGE_MS);
};
